/**
 * Mappa dinamica dei nomi icona (dal DB `categories.icon`) ai componenti Lucide.
 *
 * Usa `import * as LucideIcons` così tutte le icone disponibili nella libreria
 * sono automaticamente supportate senza dover mantenere una mappa manuale.
 * In caso di nome non trovato, ritorna `Package` come fallback.
 *
 * Aliasi noti dal DB verso nomi Lucide reali (es. "Home" -> "House").
 */
import * as LucideIcons from 'lucide-react';

const ALIASES = {
  Home: 'House',
  GiftIcon: 'Gift',
  LayoutTemplate: 'Layout',
  History: 'Clock',
  Signpost: 'Flag',
  Confetti: 'PartyPopper',
};

const FALLBACK = LucideIcons.Package;

export const getIconComponent = (iconName) => {
  if (!iconName) return FALLBACK;
  const resolvedName = ALIASES[iconName] || iconName;
  return LucideIcons[resolvedName] || FALLBACK;
};
